module.exports = __webpack_public_path__ + "media/latam/bghead-cbde0a26.png";